import styled from 'styled-components';

export const Logo = styled.svg`
  display: block;
  width: auto;
`;
